
  var _styles = {
  "publicity-popup-card": {
    "display": "flex",
    "width": "7.52rem",
    "height": "10.28rem",
    "flexDirection": "column",
    "alignItems": "center",
    "backgroundColor": "rgb(9,145,241)",
    "borderRadius": "0.48rem",
    "position": "relative",
    "padding": "0.32rem"
  },
  "publicity-popup-header": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "width": "100%",
    "position": "relative",
    "marginTop": "0.26667rem"
  },
  "publicity-popup-title-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative",
    "marginBottom": "0.13333rem"
  },
  "publicity-popup-title-icon": {
    "width": "0.44rem",
    "height": "0.48rem",
    "borderRadius": "0.16rem",
    "marginTop": 0,
    "marginRight": "0.21333rem",
    "marginBottom": 0,
    "marginLeft": "0.21333rem"
  },
  "publicity-popup-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.48rem",
    "maxWidth": "2.98667rem",
    "textAlign": "center",
    "marginLeft": "0.16rem",
    "marginRight": "0.16rem"
  },
  "publicity-popup-call-section": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "publicity-popup-call-icon": {
    "width": "0.26667rem",
    "height": "0.37333rem",
    "borderRadius": "0.05333rem",
    "marginRight": "0.12rem"
  },
  "publicity-popup-call-label": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "left"
  },
  "publicity-popup-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "0.76rem"
  },
  "publicity-popup-rank-section": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "publicity-popup-rank-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.53333rem",
    "textAlign": "center"
  },
  "publicity-popup-rank-highlight": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.53333rem",
    "textAlign": "center",
    "marginLeft": "0.10667rem"
  },
  "publicity-popup-winners": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "0.44rem",
    "width": "7.52rem",
    "paddingLeft": "0.53333rem",
    "paddingRight": "0.57333rem"
  },
  "publicity-popup-winners-title": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center",
    "marginBottom": "0.13333rem"
  },
  "publicity-popup-winners-list": {
    "display": "flex",
    "flexDirection": "column",
    "width": "7.52rem",
    "height": "4.66667rem",
    "paddingLeft": "0.53333rem",
    "paddingRight": "0.57333rem"
  },
  "publicity-popup-winner-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.21333rem",
    "paddingRight": 0,
    "paddingBottom": "0.21333rem",
    "paddingLeft": 0,
    "borderBottomWidth": "0.01333rem",
    "borderBottomStyle": "solid",
    "borderBottomColor": "rgba(169,216,255,0.3)"
  },
  "publicity-popup-winner-rank": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "textAlign": "center",
    "marginRight": "0.19733rem",
    "width": "0.6rem"
  },
  "publicity-popup-winner-info": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1
  },
  "publicity-popup-winner-name": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "lineHeight": "0.38667rem",
    "textAlign": "left",
    "marginBottom": "0.10667rem",
    "maxWidth": "3.14667rem"
  },
  "publicity-popup-winner-call": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "publicity-popup-winner-call-icon": {
    "width": "0.26667rem",
    "height": "0.37333rem",
    "borderRadius": "0.05333rem",
    "marginRight": "0.12rem"
  },
  "publicity-popup-winner-call-text": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "left"
  },
  "publicity-popup-winner-status": {
    "color": "rgb(194,194,194)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "left"
  },
  "publicity-popup-buttons": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.56rem",
    "width": "100%"
  },
  "publicity-popup-confirm-btn": {
    "width": "6.70667rem",
    "height": "1.2rem",
    "borderRadius": "7.45333rem",
    "borderWidth": "none",
    "borderColor": null,
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "publicity-popup-confirm-text": {
    "color": "rgb(17,17,17)",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "publicity-popup-close-icon": {
    "position": "relative",
    "width": "0.32rem",
    "height": "0.32rem"
  },
  "publicity-popup-close-line": {
    "position": "absolute",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.05333rem"
  },
  "publicity-popup-close-line-1": {
    "width": "0.30667rem",
    "height": "0.04rem",
    "top": "50%",
    "left": "50%"
  },
  "publicity-popup-close-line-2": {
    "width": "0.30667rem",
    "height": "0.04rem",
    "top": "50%",
    "left": "50%"
  }
};



  module.exports = _styles;
  